import { useContext, useEffect, useState } from 'react';
import { useBreadcrumbsActions } from '../../../common/components/Breadcrumbs/context/useBreadcrumbsActions';
import { Flexbox } from '@hiiretail/synergy-ui';
import { NotificationsContext } from '../../../common/notifications/Notifications';
import { CreateButton } from '../../../common/components/Breadcrumbs/buttons/CreateButton/CreateButton';
import { CreateUserDto, UserDto, UsersApi } from "../../../api-client";
import { getApiConfiguration } from '../../../common';
import { useCreateUser } from "./useCreateUser";
import { UseMutateFunction } from "react-query";
import { AxiosResponse } from "axios";
import { ErrorResponse } from "../../../common/types/errorRespose";

type UseCreateUserModal = (isSearching: boolean) => {
  isCreateUserModalOpen: boolean,
  closeCreateUserDialog: () => void,
  createUser: UseMutateFunction<AxiosResponse<UserDto>, ErrorResponse, CreateUserDto>,
  isCreating: boolean,
  createError: ErrorResponse | null,
};

export const useCreateUserModal: UseCreateUserModal = (isSearching) => {
  const [isCreateUserModalOpen, setIsCreateUserModalOpen] = useState(false);

  const { showNotification } = useContext(NotificationsContext);
  const { updateActions } = useBreadcrumbsActions();

  const openCreateUserDialogOpen = () => setIsCreateUserModalOpen(true);

  const closeCreateUserDialog = () => setIsCreateUserModalOpen(false);

  const onUserCreationSuccess = () => {
    showNotification('User was successfully created!');
    closeCreateUserDialog();
  };

  const usersApi = new UsersApi(getApiConfiguration());

  const {
    mutate: createUser,
    isLoading: isCreating,
    error: createError,
  } = useCreateUser(usersApi, {
    onSuccess: onUserCreationSuccess,
  });

  useEffect(() => {
    updateActions(
      <>
        <Flexbox item>
          <CreateButton
            title="New user"
            onClick={openCreateUserDialogOpen}
            permission="iam.user.create"
            disabled={isCreating || isSearching}
          />
        </Flexbox>
      </>,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCreating, isSearching]);

  return {
    isCreateUserModalOpen,
    closeCreateUserDialog,
    createUser,
    isCreating,
    createError,
  };
}
